export const EAuthAction = {
  SET_USER: 'SET_USER',
  SET_AUTH_USER_PENDING: 'SET_AUTH_USER_PENDING',
  SET_AUTH_USER_PENDING_SUCCESS: 'SET_AUTH_USER_PENDING_SUCCESS',
  SET_AUTH_USER: 'SET_AUTH_USER',
  SET_AUTH_USER_SUCCESS: 'SET_AUTH_USER_SUCCESS',
};
